/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Placewebphotoshint3Inputs */

const en_placewebphotoshint3 = /** @type {(inputs: Placewebphotoshint3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected, the starred photo is the cover`)
};

const de_placewebphotoshint3 = /** @type {(inputs: Placewebphotoshint3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählt, das Foto mit Stern ist das Titelbild`)
};

/**
* | output |
* | --- |
* | "{count} selected, the starred photo is the cover" |
*
* @param {Placewebphotoshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebphotoshint3 = /** @type {((inputs: Placewebphotoshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebphotoshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebphotoshint3(inputs)
	return de_placewebphotoshint3(inputs)
});
export { placewebphotoshint3 as "placeWebPhotosHint" }